import React from 'react'
import HomePageLayout from '../Layout/HomePageLayout';
import { Button } from 'antd'
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  return (
    <HomePageLayout>
      <div>
        <p>Oops!. 404 Not Found </p>
        <Button type="primary">
          <Link to="/">
            Back to Home
          </Link>
        </Button>
      </div>
    </HomePageLayout>
  )
}

export default NotFoundPage